/**************************************************************************************************/
/*   File: /src/app/shared/components/message-box/message-box.component.ts                        */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { NGXLogger } from 'ngx-logger';
import { timer, Subscription } from 'rxjs';

import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { environment } from '../../../../environments/environment.demo';
import * as fromEnums from '../../enums';
import { Message } from '../../models';

/**
 * The message box component
 */
@Component({
  selector: 'nwpl-frnt-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss']
})
export class MessageBoxComponent implements OnInit, OnDestroy {

  /**
   * The message to show
   */
  @Input() message: Message;

  /**
   * Emitter for closed button pressed
   */
  @Output() closed: EventEmitter<Message> = new EventEmitter<Message>();

  /**
   * Expose the message type
   */
  MessageType = fromEnums.MessageType;
  /**
   * The array of subscription
  */
  private subscriptions: Subscription[] = [];

  /**
   * The constructor
   */
  constructor(private logger: NGXLogger) { }

  /**
   * The ng on init hook
   */
  ngOnInit() {
    const source = timer(environment.messageTimeout);
    const subscriptionSource = source.subscribe((end) => {
      /* istanbul ignore next */
      if (this.message && this.message.isClosable) {
        this.closed.emit(this.message);
      }
    });
    this.subscriptions.push(subscriptionSource);

  }

  /**
   * The ng on destroy hook
   */
  /* istanbul ignore next */
  ngOnDestroy(): void {
    /* this.logger.trace('Remove subscriptions MessageBoxComponent'); */
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  /**
   * On close pressed
   * @param event$ 
   */
  onClose(event$: Event) {
    if (this.message && this.message.isClosable) {
      this.logger.trace('Pressed on close');
      this.closed.emit(this.message);
    }
  }

}
